module.exports = __webpack_public_path__ + "img/news-image6.cdffc63a.png";